import liffSDK from "@line/liff";
import mockLiff from "./mockLiff";

const useMock = process.env.REACT_APP_USE_MOCK === "true";

const liff = useMock ? mockLiff : liffSDK;

if (useMock) {
    console.log(
        "%c[LIFF] Running in MOCK mode",
        "background: #222; color: #bada55; padding: 4px; border-radius: 4px;"
    );
}

export default liff;
